var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-layout-fixer"},[_c('VueWrapperNarrow',[_c('div',{staticClass:"cookie-policy-wrapper",attrs:{"id":"divCookiePolicyWrapper"}},[_c('BrandCookies')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }